<div class="whatsapp-report-container">
  <!-- Header -->
<div class="dialog-header flex items-center justify-between">
  <div class="flex items-center gap-3">
    <span class="report-title flex items-center gap-2">
      <i class="pi pi-chart-bar"></i>
      WhatsApp Campaign Report
    </span>
  </div>
  <div class="absolute right-4">
     <button pButton type="button" icon="pi pi-refresh" label="Refresh" class="mr-3" (click)="refreshReport()" [disabled]="loading"></button>
    <button (click)="close()" class="text-white hover:text-gray-300">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container dialog-content">
    <p-progressSpinner></p-progressSpinner>
    <p class="loading-text">Loading WhatsApp report data...</p>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loading && reportData" class="dialog-content report-content">
    
    <!-- Statistics Overview -->
    <div class="statistics-grid">
      <div class="stat-card stat-sent">
        <div class="stat-icon">
          <i class="pi pi-send"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Sent</p>
          <h3 class="stat-value">{{ statistics.sent }}</h3>
          <p class="stat-percentage">100%</p>
        </div>
      </div>

      <div class="stat-card stat-delivered">
        <div class="stat-icon">
          <i class="pi pi-check-circle"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Delivered</p>
          <h3 class="stat-value">{{ statistics.uniqueDelivered || 0 }}</h3>
          <p class="stat-percentage">{{ statistics.sent > 0 ? ((statistics.uniqueDelivered || 0) / statistics.sent * 100).toFixed(1) : 0 }}%</p>
        </div>
      </div>

      <div class="stat-card stat-read">
        <div class="stat-icon">
          <i class="pi pi-eye"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Read</p>
          <h3 class="stat-value">{{ statistics.uniqueRead || 0 }}</h3>
          <p class="stat-percentage">{{ calculateReadRate().toFixed(1) }}%</p>
        </div>
      </div>

      <div class="stat-card stat-failed">
        <div class="stat-icon">
          <i class="pi pi-exclamation-triangle"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Failed</p>
          <h3 class="stat-value">{{ statistics.failed }}</h3>
          <p class="stat-percentage">{{ calculateFailureRate().toFixed(1) }}%</p>
        </div>
      </div>
    </div>

    <!-- View Toggle -->
    <div class="view-toggle">
      <p-selectButton 
        [options]="[
          { label: 'Table View', value: 'table', icon: 'pi pi-table' },
          { label: 'Graph View', value: 'graph', icon: 'pi pi-chart-bar' }
        ]" 
        [(ngModel)]="activeView"
        optionLabel="label"
        optionValue="value">
        <ng-template let-item>
          <i [class]="item.icon"></i>
          <span class="ml-2">{{ item.label }}</span>
        </ng-template>
      </p-selectButton>
    </div>

    <!-- Table View -->
    <div *ngIf="activeView === 'table'" class="table-view">
      <!-- Status Tabs -->
      <div class="status-tabs">
        <div 
          *ngFor="let tab of statusTabs" 
          class="status-tab"
          [class.active]="activeTab === tab.value"
          (click)="filterDataByStatus(tab.value)">
          <i [class]="tab.icon"></i>
          <span class="tab-label">{{ tab.label }}</span>
          <span class="tab-count">{{ tab.count }}</span>
        </div>
      </div>

      <!-- Data Table -->
      <div class="data-table-container">
        <p-table 
          [value]="getDisplayData()" 
          [paginator]="true" 
          [rows]="10"
          [rowsPerPageOptions]="[10, 25, 50, 100]"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          styleClass="p-datatable-sm">
          
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let col of getDisplayColumns()" [pSortableColumn]="col.sortable ? col.field : ''">
                {{ col.header }}
                <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <!-- Grouped View (Read/Delivered) -->
            <tr *ngIf="isGroupedView()">
              <td>
                <div class="phone-cell">
                  <i class="pi pi-phone"></i>
                  <span>{{ item.recipient_phone }}</span>
                </div>
              </td>
              <td>
                <span class="event-count-badge">
                  <i class="pi pi-replay"></i>
                  {{ item.event_count }} {{ item.event_count === 1 ? 'time' : 'times' }}
                </span>
              </td>
              <td>
                <div class="timestamp-cell">
                  <i class="pi pi-clock"></i>
                  <span>{{ formatTimestamp(item.first_event) }}</span>
                </div>
              </td>
              <td>
                <div class="timestamp-cell">
                  <i class="pi pi-clock"></i>
                  <span>{{ formatTimestamp(item.last_event) }}</span>
                </div>
              </td>
            </tr>

            <!-- Regular View -->
            <tr *ngIf="!isGroupedView()">
              <td>
                <div class="phone-cell">
                  <i class="pi pi-phone"></i>
                  <span>{{ item.recipient_phone }}</span>
                </div>
              </td>
              <td>
                <span class="event-type-badge">{{ item.event_type }}</span>
              </td>
              <td>
                <span class="status-badge" [ngClass]="getStatusBadgeClass(item.status)">
                  {{ item.status }}
                </span>
              </td>
              <td>
                <div class="timestamp-cell">
                  <i class="pi pi-clock"></i>
                  <span>{{ formatTimestamp(item.event_at) }}</span>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="getDisplayColumns().length" class="text-center">
                <div class="empty-state">
                  <i class="pi pi-inbox"></i>
                  <p>No tracking data available for this status</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- Graph View -->
    <div *ngIf="activeView === 'graph'" class="graph-view">
      <div class="charts-container">

        <!-- Key Metrics Card -->
        <div class="chart-card metrics-card">
          <div class="chart-header">
            <h3 class="chart-title">
              <i class="pi pi-info-circle"></i>
              Key Metrics
            </h3>
            <p class="chart-subtitle">Campaign performance indicators</p>
          </div>
          <div class="metrics-content">
            <div class="metric-item">
              <div class="metric-icon delivery">
                <i class="pi pi-check-circle"></i>
              </div>
              <div class="metric-info">
                <p class="metric-label">Delivery Rate</p>
                <p class="metric-value">{{ calculateDeliveryRate().toFixed(2) }}%</p>
                <p class="metric-description">Delivered / Sent messages</p>
              </div>
            </div>

            <div class="metric-item">
              <div class="metric-icon read">
                <i class="pi pi-eye"></i>
              </div>
              <div class="metric-info">
                <p class="metric-label">Read Rate</p>
                <p class="metric-value">{{ calculateReadRate().toFixed(2) }}%</p>
                <p class="metric-description">Read / Delivered messages</p>
              </div>
            </div>

            <div class="metric-item">
              <div class="metric-icon failure">
                <i class="pi pi-exclamation-triangle"></i>
              </div>
              <div class="metric-info">
                <p class="metric-label">Failure Rate</p>
                <p class="metric-value">{{ calculateFailureRate().toFixed(2) }}%</p>
                <p class="metric-description">Failed / Total messages</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Status Distribution Pie Chart -->
        <div class="chart-card pie-chart-card">
          <div class="chart-header">
            <h3 class="chart-title">
              <i class="pi pi-chart-pie"></i>
              Status Distribution
            </h3>
            <p class="chart-subtitle">Message status breakdown</p>
          </div>
          <p-chart type="pie" [data]="statusChartData" [options]="statusChartOptions" class="chart-content"></p-chart>
        </div>

        <!-- Status Timeline Bar Chart -->
        <div class="chart-card bar-chart-card">
          <div class="chart-header">
            <h3 class="chart-title">
              <i class="pi pi-chart-bar"></i>
              Message Status Timeline
            </h3>
            <p class="chart-subtitle">Event distribution</p>
          </div>
          <p-chart type="bar" [data]="timelineChartData" [options]="timelineChartOptions" class="chart-content"></p-chart>
        </div>
      </div>
    </div>

  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && !reportData" class="dialog-content empty-report">
    <div class="empty-state">
      <i class="pi pi-inbox"></i>
      <p>No report data available</p>
      <p class="text-sm text-gray-500">The campaign may not have started yet or no tracking data is available.</p>
    </div>
  </div>
</div>
